


























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util';
    import AbpBase from '@/lib/abpbase';
    import * as proxy from '@/lib/service-proxies/service-proxies';
    import vueformmodel from '@/lib/vueformmodel';
    @Component
    export default class EditUser extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;

        model=new proxy.ChangePasswordDto();

        get prox() {
            return new proxy.UserServiceProxy();
        }
        
        created() {
            this.model=new proxy.ChangePasswordDto();
        }
        save() {
            
            (this.$refs.userForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.prox.changePassword(this.model).then(() => {
                        (this.$refs.userForm as any).resetFields();
                        this.$Notice.success({title:'保存成功,请重新登陆'});
                        this.$store.commit('app/logout', this);
                        this.$emit('input', false);
                        Util.abp.auth.clearToken();
                        location.reload();
                        
                    });
                }
            });
        }

        pwdValidate(rule, value, callback) {
            (this.$refs.userForm as any).validateField('againPassword');
            callback();
        };
        pwdCheckValidate (rule, value, callback){
            
            if (!this.model.newPassword && !value) {
                callback(new Error('确认密码不能为空'));
            } else if (this.model.newPassword != value) {
                callback(new Error('新密码和确认密码应相同'));
            } else {
                callback();
            }
        };
       
        cancel() {
            (this.$refs.userForm as any).resetFields();
            this.$emit('input', false);
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.model=new proxy.ChangePasswordDto();
            }
        }

        userRule = {
            currentPassword: [{ required: true,  message: this.L('FieldIsRequired'), trigger: 'blur' }],
            newPassword: [{  validator: this.pwdValidate, trigger: 'blur' }],
            againPassword: [{ validator: this.pwdCheckValidate, trigger: 'blur' }],
            
        };


}
